import { apiClient } from '~/shared/api/data-ingestion-api'
import { CONSIGNMENT_SERVER_STATUS } from '../config'
import type { UIConsignmentStatus } from './types'

export function getReviewStatus(status: UIConsignmentStatus[]): apiClient.ReviewStatusEnum | null {
  if (status.includes('awaiting')) {
    return CONSIGNMENT_SERVER_STATUS.pending
  }
  if (status.includes('finished')) {
    return CONSIGNMENT_SERVER_STATUS.reviewed
  }
  if (status.includes('auto_reviewed')) {
    return CONSIGNMENT_SERVER_STATUS.auto_reviewed
  }
  return null
}
